import { render, staticRenderFns } from "./ProductionStoreScanIndex.vue?vue&type=template&id=0bf3b4c6&"
import script from "./ProductionStoreScanIndex.vue?vue&type=script&lang=js&"
export * from "./ProductionStoreScanIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports